import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "fim-cookie-consent-v1";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Don't show inside the embed iframe
    if (typeof window !== "undefined" && window.location.pathname.startsWith("/embed")) return;
    const accepted = typeof window !== "undefined" && window.localStorage.getItem(STORAGE_KEY);
    if (!accepted) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch (err) {
      // localStorage may be unavailable (private mode, blocked storage, etc.).
      // The user can still dismiss the banner; we just won't remember the choice next visit.
      console.warn("[cookie-consent] localStorage write failed:", err?.message);
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 lg:bottom-6 lg:left-6 lg:right-auto lg:max-w-md z-[2000] animate-fade-in"
    >
      <div className="bg-[var(--navy-950)] text-[var(--bone)] border border-[var(--gold)]/30 shadow-2xl p-6 lg:p-7 relative">
        <button
          data-testid="cookie-dismiss"
          onClick={accept}
          aria-label="Dismiss"
          className="absolute top-3 right-3 text-[var(--navy-100)]/60 hover:text-[var(--bone)]"
        >
          <X size={16} />
        </button>
        <div className="flex items-center gap-2 text-[var(--gold-soft)]">
          <Cookie size={16} />
          <span className="text-[10px] tracking-[0.32em] uppercase font-bold">Privacy Notice</span>
        </div>
        <p className="mt-4 text-[13px] leading-[1.6] text-[var(--navy-100)]/90">
          This site uses essential cookies and local storage to operate the chat widget and remember your preferences.
          By continuing, you agree to our{" "}
          <Link to="/privacy" className="text-[var(--gold-soft)] underline hover:text-[var(--gold)]">
            Privacy Policy
          </Link>
          {" "}and{" "}
          <Link to="/terms" className="text-[var(--gold-soft)] underline hover:text-[var(--gold)]">
            Terms of Use
          </Link>.
        </p>
        <button
          data-testid="cookie-accept"
          onClick={accept}
          className="btn-gold mt-5 px-5 py-2.5 rounded-full text-[11px] tracking-[0.22em] uppercase font-bold"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
